/* @ngInject */
const myContactsForm = (
  valueHandler,
  toaster,
  $$contact
) => {
  return {
    restrict: 'E',
    scope: {
      myContacts: '=',
      enableValidator: '=?',
    },
    template: require('./myContactsForm.html'),

    /* @ngInject */
    controller: ($scope) => {

      $scope.addContact = () => {
        $scope.myContacts.push($$contact.new())
      }

      $scope.removeContact = async (_index) => {
        const id = $scope.myContacts[_index].id
        if (valueHandler.isId(id)) {
          try {
            const message = await $$contact.request.delete(id)
            toaster.message(message)
            $scope.myContacts.splice(_index, 1)
          } catch (error) {
            toaster.error(error)
          }
        } else {
          $scope.myContacts.splice(_index, 1)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myContactsForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/directives/form/myContactsForm.js